import BackendAPI from '@/utils/backendAPI.js';

export default {
  async fetchOrders({ commit }, payload) {
    const pagenation = {
      per_page: payload.perPage,
      current_page: payload.currentPage,
      order_status: payload.orderStatus,
      start_date: payload.startDate,
      end_date: payload.endDate,
      driver_name: payload.driverName,
      user_name: payload.userName
    };
    const res = await BackendAPI.get('/long_term_care/order/all', {
      params: pagenation
    });

    if (!res.result.data) {
      commit('orders', []);
      commit('ordersPagenation', {
        currentPage: 1,
        nextPage: 2,
        previousPage: null,
        totalPages: null,
        perPage: 25,
        totalEntries: null
      });
      return;
    }

    commit('orders', res.result.data);
    commit('ordersPagenation', res.result.paging);

    return res;
  },
  async fetchOrdersTotalStatus({ commit }) {
    const res = await BackendAPI.get('/long_term_care/order/total');
    commit('ordersTotalStatus', res.result);
  },
  async updateOrderStatus(_context, { orderId, payload }) {
    await BackendAPI.put(`/long_term_care/order/status/${orderId}`, payload);
  },
  async updateOrderDriver(_context, { orderId, payload }) {
    const res = await BackendAPI.put(
      `/long_term_care/order/assign_driver/${orderId}`,
      payload
    );
    return res;
  },
  async addOrder(_context, orderData) {
    const res = await BackendAPI.post('/long_term_care/order', orderData);
    return res;
  },
  async addOrderMakeup(_context, orderData) {
    const res = await BackendAPI.post('/long_term_care/order/fill', orderData);
    return res;
  },
  async updateOrder(_context, { orderData, orderId }) {
    const res = await BackendAPI.put(
      `/long_term_care/order/${orderId}`,
      orderData
    );
    return res;
  },
  async fetchUserSearch({ commit }, userData) {
    const res = await BackendAPI.get('/long_term_care/user/search', {
      params: userData
    });
    commit('usersSearchResult', res.result);
  },
  async fetchUserDetailSearch({ commit }, userID) {
    try {
      const res = await BackendAPI.get(`/long_term_care/user/search/${userID}`);
      commit('userDetailSearchResult', res.result);
      if (!res.result.historyAddressData.length) {
        commit('userHistoryAddress', []);
      } else {
        const userHistoryAddress = res.result.historyAddressData.map(item => {
          return {
            address: item.address,
            longitude: item.gps[0],
            latitude: item.gps[1]
          };
        });
        commit('userHistoryAddress', userHistoryAddress);
      }
    } catch (err) {
      return err;
    }
  },
  async fetchOrderDriverSearch({ commit }, { driverData, dataType }) {
    const res = await BackendAPI.get('/long_term_care/order/driver', {
      params: driverData
    });

    if (dataType === 'driverId')
      commit('orderDriverIDSearchResult', res.result);
    if (dataType === 'licenseNumber')
      commit('orderLicenseNumberSearchResult', res.result);
  },
  async fetchOrderAutoCountMetreFare(
    { commit, getters },
    { longTermCareUserId, fareData }
  ) {
    const res = await BackendAPI.get(
      `/long_term_care/user/fare/${longTermCareUserId}`,
      {
        params: fareData
      }
    );
    commit('orderData', {
      ...getters.orderData,
      subsidyFare: res.result.subsidyFare,
      actualFare: res.result.actualFare
    });
  },
  async fetchOrder({ commit, getters }, orderId) {
    const res = await BackendAPI.get(`/long_term_care/order/${orderId}`);
    commit('order', res.result);

    const data = Object.keys(res.result).reduce((accu, curr) => {
      if (!res.result[curr]) return accu;
      Object.keys(res.result[curr]).forEach(property => {
        if (property === 'serviceList') {
          if (!res.result[curr][property].length) {
            accu.service = res.result[curr][property];
            return;
          }
          accu.service = res.result[curr][property].map(
            item => item.teamServiceId
          );
        }

        if (property === 'milage') {
          accu[property] = Number(res.result[curr][property]);
          return;
        }

        if (Object.prototype.hasOwnProperty.call(getters.orderData, property))
          accu[property] = res.result[curr][property];
        return;
      });
      return accu;
    }, {});
    commit('orderData', data);
  },
  async deleteOrder(_context, orderId) {
    const res = BackendAPI.delete(`/long_term_care/order/${orderId}`);
    return res;
  },
  async cancelOrder(_context, { orderId, cancelReason }) {
    const res = BackendAPI.put(
      `/long_term_care/order/cancel/${orderId}`,
      cancelReason
    );
    return res;
  },
  async fetchServiceOptions({ commit }) {
    const res = await BackendAPI.get('/long_term_care/team/service');
    commit('serviceOptions', res.result);
  },

  async fetchLocationList({ commit }, keyword) {
    const res = await BackendAPI.get('/search/address/v2/', {
      params: { address: keyword }
    });

    if (res.success) {
      commit('locationList', res.result.addressArray);
    }
  },
  async fetchGoogleLocationList({ commit }, keyword) {
    commit;
    keyword;
  },
  async fetchCustomizeLocation({ commit }, payload) {
    const res = await BackendAPI.get('/landmark/gethailinglist', {
      params: payload
    });

    if (res.result === 'err') return;
    const locationArray = res.result.landmarkInfo.map(item => {
      return {
        address: item.name + '-' + item.address.split('台灣')[1],
        gps: {
          coordinates: item.addressGPS.coordinates
        },
        name: item.name
      };
    });
    commit('locationList', locationArray);
  },

  async fetchUsers({ commit }, payload) {
    const pagenation = {
      per_page: payload.perPage,
      current_page: payload.currentPage,
      keyword: payload.keyword,
      subidy_fare: payload.subidyFare
    };
    const res = await BackendAPI.get('/long_term_care/user', {
      params: pagenation
    });

    if (!res.result.data) {
      commit('users', []);
      commit('usersPagenation', {
        currentPage: 1,
        perPage: 25
      });
      return;
    }

    commit('users', res.result.data);
    commit('usersPagenation', res.result.paging);
  },
  async addUser(_context, payload) {
    const form = new FormData();
    for (let key in payload) {
      form.append(key, payload[key]);
    }

    // console.log('formData', form);

    const res = await BackendAPI.post('/long_term_care/user', form, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json'
      }
    });

    return res;
  },
  async fetchUser({ commit }, userId) {
    const res = await BackendAPI.get(`/long_term_care/user/${userId}`);

    commit('user', res.result);
  },
  async updateUser(_context, { userData, userId }) {
    const form = new FormData();
    for (let key in userData) {
      // console.log(key, userData[key]);
      form.append(key, userData[key]);
    }
    // console.log('formData', form);

    const res = BackendAPI.put(`/long_term_care/user/${userId}`, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json'
      }
    });

    return res;
  },
  async updateUserQRCode(_context, userId) {
    const res = await BackendAPI.put(`/long_term_care/user/qrcode/${userId}`);

    return res;
  },
  async deleteUser(_context, userId) {
    const res = await BackendAPI.delete(`/long_term_care/user/${userId}`);

    return res;
  },

  async fetchDailyRecordSearch({ commit }, payload) {
    const params = {
      start_date: payload.startDate,
      end_date: payload.endDate,
      driver_id: payload.driverId,
      licence: payload.licenseNumber,
      current_page: payload.currentPage
    };
    const res = await BackendAPI.get(
      '/long_term_care/order/search/daily_record',
      {
        params
      }
    );
    if (!res.result.data) {
      commit('downloadPerpageOptions', [0]);
      commit('dailyRecordSearchResult', []);
      return;
    }
    if (res.result.data.length) {
      let perpageArray = [];
      const pages = res.result.data.length / 100;
      for (let i = 1; i < pages + 1; i++) {
        perpageArray.push(i);
      }
      commit('dailyRecordSearchResult', res.result.data);
      commit('downloadPerpageOptions', perpageArray);
    }
  },
  async downloadDailyReport(_context, payload) {
    const params = {
      start_date: payload.startDate,
      end_date: payload.endDate,
      driver_id: payload.driverId,
      licence: payload.licenseNumber,
      current_page: payload.currentPage
    };
    const res = await BackendAPI.get(
      '/long_term_care/order/excel/daily_report',
      {
        responseType: 'blob',
        params
      }
    );
    return res;
  },
  async downloadMonthlyReport(_context, payload) {
    const params = {
      search_year: payload.date.split('/')[0],
      search_month: payload.date.split('/')[1],
      driver_id: payload.driverId,
      licence: payload.license
    };
    const res = await BackendAPI.get(
      '/long_term_care/order/excel/monthly_report',
      {
        responseType: 'blob',
        params
      }
    );
    return res;
  },
  async downloadGovermentReport(_context, payload) {
    const params = {
      start_date: payload.startDate,
      end_date: payload.endDate,
      licence: payload.license
    };
    const res = await BackendAPI.get(
      '/long_term_care/order/excel/ministry_of_health',
      {
        responseType: 'blob',
        params
      }
    );
    return res;
  },
  async downloadOrdersData(_context, payload) {
    const params = {
      start_date: payload.startDate,
      end_date: payload.endDate
    };
    const res = await BackendAPI.get(
      '/long_term_care/order/excel/order_detail_report',
      {
        responseType: 'blob',
        params
      }
    );

    return res;
  },

  async uploadOrsers(_context, orders) {
    const res = await BackendAPI.post('/long_term_care/order/insert', orders);
    return res;
  },
  async uploadUsers(_context, users) {
    const res = await BackendAPI.post('/long_term_care/user/insert', users);
    return res;
  }
};
